<template>

  <v-text-field
    v-bind="computedProps"
    :placeholder="phtext"
    v-on="computedListeners"/>

</template>
<script>
import controls from '@/rahmen/controls'
import complements from '@/rahmen/complement'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextField } from 'vuetify/lib'

/**
 * @file DDv2用年月入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-year-month-box
    label="適用開始年月"
    v-model="ymValue"
    max="2099/12"
    min="2000/01"/>
 */
export default {
  name: 'DdDateBox',
  extends: VTextField,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    innerValue: '',
    defaultMax: '2999/12',
    defaultMin: '2000/01'
  }),
  created () {
  },
  mounted () {
    const dtl = controls.getInputTypeDetail(controls.InputTypes.YearMonth)
    if (!dtl) { return }
    this.phtext = dtl.placeholder.replace('@@length@@', this.length)
    this.invalidMessage = this.errorMessages
    this.innerValue = this.value
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        outlined: !this.isReadonly,
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this.complement()
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        // this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
      const val = this.lazyValue
      this.innerValue = val.split('/').join('')

      const elem = this.$el.querySelector('input')
      console.log('DdDateBox.onFocus', elem)
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        this.$emit('focus', e)
      })
    },
    complement: function () {
      const val = complements.parseYearMonth(this.lazyValue)
      this.$set(this, 'innerValue', val)
      this.$emit('input', val)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        max: this.max === undefined ? this.defaultMax : this.max,
        min: this.min === undefined ? this.defaultMin : this.min
      }

      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.YearMonth)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
</style>
